import zhCN from 'antd/lib/locale/zh_CN';
import { LocalFormat } from '@/presentation/config/date_zh_CN';
zhCN.DatePicker = LocalFormat.getDefinedChineseLocal();

export default zhCN;
